<template>
  <div class="archivesRecommend" :style="boxStyle">
    <div class="mallTitle" v-if="pattern.showTitle||pattern.showMore">
      <p class="title" v-if="pattern.showTitle">{{ content.titleText }}</p>
      <p class="moreText" v-if="pattern.showMore">{{ content.moreText }}</p>
    </div>
    <div v-for="(item, index) in content.lineNum" :key="index" class="archivesLine">
      <div class="archives"></div>
      <div class="archives"></div>
    </div>
  </div>
</template>

<script>

import mixins from '../mixins/mixins'
export default {
  name: 'archivesRecommend',
  props: {},
  components: {},
  mixins: [mixins],
  data() {
    return {
      detailData: {
        list: []
      },
      pattern: {},
      content: {},
    }
  },
  watch: {
  },
  computed: {
    boxStyle(){
      return {
        "padding-left": (this.pattern.margin || 0) + 'px',
        "padding-right": (this.pattern.margin || 0) + 'px',
        "background-color":this.pattern.bgColor
      }
    },
  },
  methods: {
    async init() {
      this.detailData = await this._filter(this.itemData)
      this.pattern = this.detailData.pattern || {}
      this.content = this.detailData.content || {}
      console.log("archivesRecommend----------this.detailData");
      console.log(this.detailData);
    },
  },
  async mounted() {
    
  }
}
</script>
<style lang="scss" scoped>
.archivesRecommend{
  .mallTitle{
    height: 22px;
    line-height: 22px;
    margin-bottom: 10px;
    .title{
      font-weight: 900;
      font-size: 16px;
      color: #2E2E2E;
      display: inline-block;
    }
    .moreText{
      font-weight: 400;
      font-size: 12px;
      color: #8F9495;
      float: right;
    }
  }
  .archivesLine{
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .archives{
      width: calc(50% - 5px);
      padding-bottom: 50%;
      height: 0;
      background-image: url("../image/archivesRecommend.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
}
</style>
